/* eslint-disable */
// notificationsStore — the notification platform's own UI state.
//
// WHY THIS IS NOT "a second store for overlays"
//   Gate A's rule was: reuse the mechanism that drives overlays, do not invent a
//   parallel one. The MECHANISM here is identical to uiStore's — a Zustand
//   boolean that the mount self-gates on, exactly like showGlobalSearch. What
//   differs is the DOMAIN: this is the notification platform's state, and the
//   boundary is real. P4's drawer and P5's control panel will each want overlay
//   state of their own, and putting all three on uiStore.js means hitting the
//   same wall three more times.
//
//   The codebase already keeps state in more than one store — catalogStore.js
//   (useCatalogStore) sits beside uiStore.js — so a domain store is the existing
//   pattern rather than a new precedent.
//
// WHAT FORCED THE DECISION
//   uiStore.js is at EXACTLY 300 lines, the Convention #163 cap. A sweep of all
//   51 of its state keys found ZERO dead fields to reclaim, so the composer's two
//   fields could not be paid for there. Grandfathering does not help either: the
//   H2 hook baselines a grandfathered file against its HEAD line count, not
//   against the policy list, so a file sitting exactly at the cap has no growth
//   path at all. The split that would fix this properly is booked in
//   docs/audit/2026-08-28-uistore-split-debt.md — P3 routed around that debt
//   rather than paying it at the end of a long session.

import { create } from 'zustand';

export const useNotificationsStore = create((set) => ({
  // The announcement composer (P3). `composerItem` is the item it was opened
  // from — null when opened from the global entry point, which is what switches
  // the send between lens.favorited and system.announcement.
  showComposer: false,
  composerItem: null,

  setShowComposer: (v, item = null) =>
    set({ showComposer: v, composerItem: v ? item : null }),

  // The notification drawer (P4) — the panel behind the megaphone.
  showDrawer: false,
  setShowDrawer: (v) => set({ showDrawer: v }),
}));
